/**
 * VuePrint v1.6.3
 * Copyright (c) 2024 Jak Guru LLC
 * Vueprint a commerical work product released under the MIT License
 * and is provided as-is with no warranty or guarantee of support.
 * Documentation: https://jakguru.github.io/vueprint/
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import { g as getBrowserInfo } from './vueprint.73231624.mjs';

const getDebugger = (name, color = "#34495E", background = "#41B883") => {
  const browserInfo = getBrowserInfo();
  return (...args) => {
    if ("undefined" === typeof window && ("undefined" === typeof ServiceWorkerGlobalScope || !(self instanceof ServiceWorkerGlobalScope)) || "undefined" !== typeof window && "object" === typeof window.process && "object" === typeof window.__modules__ && "function" === typeof window.__export__ && "function" === typeof window.__dynamic_import__) {
      console.log(`[${name}]`, ...args);
      return;
    }
    if (browserInfo.browserName === "Safari") {
      console.log(
        `%c${name}`,
        `background-color: ${background}; color: ${color}; padding: 2px 4px;`,
        ...args
      );
      return;
    }
    if ("undefined" !== typeof ServiceWorkerGlobalScope && self instanceof ServiceWorkerGlobalScope) {
      if (!name.startsWith("[") && !name.endsWith("]")) {
        name = `[${name}]`;
        const oldColor = color;
        color = background;
        background = oldColor;
      }
    }
    console.groupCollapsed(
      `%c${name}`,
      `background-color: ${background}; color: ${color}; padding: 2px 4px;`,
      ...args
    );
    console.debug(new Error("stack").stack.split("\n").slice(2).join("\n"));
    console.groupEnd();
  };
};

const debug = {
  __proto__: null,
  getDebugger: getDebugger
};

export { debug as d, getDebugger as g };
//# sourceMappingURL=vueprint.b84f56b4.mjs.map
